 
 window.deferLoadingAlpine=true;

import Alpine from 'alpinejs'

//Alpine.start()

// If you want Alpine's instance to be available everywhere.
//window.Alpine = Alpine

window._ = require('lodash');
window.Swal = require('sweetalert2');

window.Popper = require('@popperjs/core').default;

const jQuery = require('jquery');;
window.$ = window.jQuery =jQuery;


require('jquery-ui/dist/jquery-ui.js');
window.colorbox = require('jquery-colorbox');
//require("tinymce");

// CoreUI
require('@coreui/coreui');
require('@coreui/utils');



window.select2=require('select2');

require('leaflet/dist/leaflet.js');
// Boilerplate
require('../plugins');

require('../utils/standalonepopup.js');

window.Push = require('push.js/bin/push.min.js');

